const API_ROUTES = Object.freeze({
  MAP_OVERLAY: "/api/map-overlays",
});

const QUERY_KEYS = Object.freeze({
  MAP_OVERLAY: "map-overlay",
  MAP_OVERLAY_VERSIONS: "map-overlay-versions",
});

export { API_ROUTES, QUERY_KEYS };
